import React from 'react';
import Skeleton from 'react-loading-skeleton';
import dayjs from 'dayjs';
import styled from 'styled-components';
import { Avatar, Cell, H4, Row, Text } from 'components';
import { theme, toRem } from 'design';
import { PaymentMethodAccountNumber } from 'forms/PaymentMethodForm/styles';
import { AcceptancePaymentMethod, IAcceptancePayment } from 'types';
import { centsToDollarsDisplay } from 'utils/currency';
import { calculateAcceptancePayoutNet } from 'utils/payout';

const FlexRow = styled.div`
  flex-flow: row nowrap;
  align-items: center;
`;

const FlexColumn = styled.div`
  flex-flow: column nowrap;
  margin-left: ${toRem(8)};

  p {
    color: ${theme.color.neutral[500]};
  }
`;

interface ITipAcceptancePaymentRow {
  payment: IAcceptancePayment;
  isLoading?: boolean;
}

const TipAcceptancePaymentRow = ({ payment, isLoading }: ITipAcceptancePaymentRow) => (
  <Row data-cy="acceptance-payment-row">
    <Cell data-cy="acceptance-employee-cell">
      <FlexRow>
        <Avatar
          size="small"
          image={payment.employee?.user?.avatarUrl}
          id={payment.employee?.id}
          username={payment.employee?.name}
          hasPaymentMethod={!!payment.employee?.user?.card}
          isDismissed={false}
          isLoading={isLoading}
          className="avatar"
        />
        <FlexColumn>
          {isLoading ? <Skeleton width={150} /> : <H4>{payment.employee?.name}</H4>}
          {isLoading ? <Skeleton width={150} /> : <Text size="small">{dayjs(payment.createdAt).format('MM/DD/YYYY hh:mm A')}</Text>}
        </FlexColumn>
      </FlexRow>
    </Cell>
    <Cell data-cy="acceptance-employee-tip-cell">{isLoading ? <Skeleton width={100} /> : centsToDollarsDisplay(payment.amount)}</Cell>
    <Cell data-cy="acceptance-employee-fees-cell">{isLoading ? <Skeleton width={100} /> : centsToDollarsDisplay(payment.fees?.total)}</Cell>
    <Cell data-cy="acceptance-employee-net-cell">{isLoading ? <Skeleton width={100} /> : centsToDollarsDisplay(calculateAcceptancePayoutNet(payment))}</Cell>
    <Cell data-cy="acceptance-employee-cardholder-cell">{isLoading ? <Skeleton width={100} /> : payment.payor?.name}</Cell>
    <Cell data-cy="acceptance-employee-card-cell">
      {isLoading ? (
        <Skeleton width={100} />
      ) : (
        <PaymentMethodAccountNumber
          cardNumber={payment.payor?.last4}
          cardType={payment.payor?.network}
          align="start"
          hideRedacted
          isApplePay={payment.paymentMethod === AcceptancePaymentMethod.APPLE_PAY}
          short
          fontSize="small"
          fontWeight="regular"
        />
      )}
    </Cell>
  </Row>
);
export default TipAcceptancePaymentRow;
